import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { HeroSection } from "@/components/sections/HeroSection";
import { AboutSection } from "@/components/sections/AboutSection";
import { SolutionsSection } from "@/components/sections/SolutionsSection";
import { DifferentialsSection } from "@/components/sections/DifferentialsSection";
import { ClientsSection } from "@/components/sections/ClientsSection";
import { ContactSection } from "@/components/sections/ContactSection";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-transparent">
      <Header />

      <main className="relative">
        {/* Seções principais com transições suaves */}
        <HeroSection />

        <div className="relative z-10">
          <AboutSection />
          <div className="premium-line opacity-20" />{" "}
          {/* Linha de divisão sutil */}
          <SolutionsSection />
          <DifferentialsSection />
          <div className="premium-line opacity-20" />
          <ClientsSection />
          <ContactSection />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default LandingPage;
